import { useEffect } from 'react'
import { Navigate, useLocation, Outlet } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'

import HeadHelmet from 'components/route/HeadHelmet'
import { setEntryPath } from 'store/authentication/utils'
import { selectRoute, updateRoute } from 'store/route/slice'
import AppContainer from 'components/layout/AppContainer'
import SiteFooter from 'components/layout/SiteFooter'
import useRouteData from 'hooks/useRouteData'
import { SITE_ADMIN_ROOT } from 'config'
import { useAuth } from 'react-oidc-context'
import useUserRole from 'hooks/useUserRole'
import OverlayLoader from 'components/ui/OverlayLoader'

export default function UserGuard(): JSX.Element {
  const userRoute = useSelector(selectRoute)
  const location = useLocation()
  const dispatch = useDispatch()
  const { titleId = '', path, notEntryRoute, outsideLayout } = useRouteData()
  const entryPathEnabled = notEntryRoute !== true
  const { isAdmin, isAdminCourseEditor } = useUserRole()
  const oicdAuth = useAuth()

  useEffect(() => {
    if (!userRoute.path || (userRoute.path && path && userRoute.path !== path)) {
      const newPath = `${location.pathname}${location.search}`
      const payload = { path, titleId, uri: newPath }
      dispatch(updateRoute(payload))
      if (entryPathEnabled) {
        setEntryPath(newPath)
      }
    }
  }, [location, dispatch, path, titleId, userRoute.path, entryPathEnabled])

  if (oicdAuth.isAuthenticated && (isAdmin || isAdminCourseEditor)) {
    return <Navigate to={SITE_ADMIN_ROOT} />
  }

  if (oicdAuth.isLoading) {
    return <OverlayLoader visible={true} />
  }

  if (outsideLayout) {
    return (
      <>
        <HeadHelmet titleId={titleId} />
        <Outlet />
      </>
    )
  }
  return (
    <>
      <HeadHelmet titleId={titleId} />
      <AppContainer>
        <Outlet />
      </AppContainer>
      <SiteFooter />
    </>
  )
}
